import type { NotificationIncreaseText } from './helpers/types';
import type { NotificationType } from './types';

export const NOTIFICATION_MAP: Record<NotificationType, NotificationType> = {
  behavior: 'behavior',
  performance: 'performance',
};

export const NOTIFICATION_INCREASE_TEXT: Record<
  NotificationIncreaseText,
  NotificationIncreaseText
> = {
  aumentado: 'aumentado',
  disminuido: 'disminuido',
};
